import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'coin-c-component-tooltip',
  templateUrl: './component-tooltip.component.html',
  styleUrls: ['./component-tooltip.component.scss'],
  standalone: false
})
export class ComponentTooltipComponent {
  @Input() icon: string;
  @Input() triggerComponent: TemplateRef<unknown>;
  @Input() disable = false;
  @Input() iconSize = '15px';
  public isVisible: boolean;

  public displayOverlay(): void {
    if (!this.disable) {
      this.isVisible = true;
    }
  }

  public hideOverlay(): void {
    this.isVisible = false;
  }
}
